import { Typography } from "@material-ui/core";

interface iMuiTitle{
    title:string;
}
const MuiTitle = ({title}:iMuiTitle)=>{
    return <Typography component={'div'}  variant="subtitle2" style={{ position: 'relative', marginBottom: 10, marginTop: 10 }}>{title}</Typography>
}

export default MuiTitle;